/**
 * One grid for every step of the medication form.
 *
 * Two columns on a desktop, one on a phone — the dialog stays the width it has
 * always been, and the form's twenty-odd fields are kept off one endless scroll
 * by the stepper rather than by a wider box.
 *
 * Spans use `1 / -1` rather than a column count, so a field that wants the
 * whole row gets it at every breakpoint without a per-breakpoint override.
 */
export const MEDICATION_FORM_GRID = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
  alignItems: 'start',
  columnGap: { xs: 2, md: 3 },
  rowGap: { xs: 2, md: 2.5 },
};

/** The whole row — the medicine picker, checkboxes, notices. */
export const SPAN_FULL = { gridColumn: '1 / -1' };

/**
 * The free-text areas. At two columns that is the whole row too, but the intent
 * differs: these want space, they don't want to break the row.
 */
export const SPAN_WIDE = { gridColumn: '1 / -1' };
